module.exports = __webpack_public_path__ + "34736292/img/mini-logo.18817ee5.svg";